var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.file.fileName,
        visible: true,
        "append-to-body": "",
        width: "80%",
        top: "5vh",
      },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "audit-preview",
        },
        [
          _vm.error
            ? _c("el-alert", {
                attrs: { title: _vm.error, type: "warning", closable: false },
              })
            : _vm._e(),
          _vm.url && _vm.file.fileKind === "IMAGE"
            ? _c("img", { attrs: { src: _vm.url, alt: "聊天图片" } })
            : _vm.url && _vm.file.fileKind === "VIDEO"
            ? _c("video", { attrs: { src: _vm.url, controls: "" } })
            : _vm.url && _vm.file.fileKind === "VOICE"
            ? _c("audio", { attrs: { src: _vm.url, controls: "" } })
            : _vm.text !== null
            ? _c("pre", [_vm._v(_vm._s(_vm.text))])
            : _vm.html
            ? _c("iframe", {
                ref: "frame",
                attrs: {
                  srcdoc: _vm.html,
                  sandbox: "allow-scripts",
                  referrerpolicy: "no-referrer",
                  title: "聊天附件只读预览",
                },
              })
            : !_vm.loading && !_vm.error
            ? _c("p", [_vm._v("此格式请下载后使用对应应用查看。")])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.downloading },
              on: { click: _vm.download },
            },
            [_vm._v("下载原文件")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }